import { render, staticRenderFns } from "./trainAdminCreationCompetitionOne.vue?vue&type=template&id=28598476&scoped=true"
import script from "./trainAdminCreationCompetitionOne.vue?vue&type=script&lang=js"
export * from "./trainAdminCreationCompetitionOne.vue?vue&type=script&lang=js"
import style0 from "./trainAdminCreationCompetitionOne.vue?vue&type=style&index=0&id=28598476&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28598476",
  null
  
)

export default component.exports